/* SkiMoji: blendet Bereiche auf dem Handy beim Scrollen sanft ein.
   Ohne dieses Skript bleibt alles sichtbar, weil erst das Skript die Ausgangsklasse setzt. */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (!window.matchMedia('(max-width: 899px)').matches) return;

  var SELECTOR = [
    '.sm-trustbox',
    '.sm-buybox .sm-acc',
    '.sm-statement__head',
    '.sm-shots__item',
    '.sm-rev__title',
    '.sm-rev__sub',
    '.sm-rev__card',
    '.sm-faq__grid > div:first-child',
    '.sm-faq .sm-acc details',
    '.sm-close__grid > div:last-child',
    '.sm-footer__grid > *',
    '.sm-contact__card',
    '.sm-contact__formbox',
    '.sm-withdraw__box'
  ].join(',');

  function init() {
    var items = document.querySelectorAll(SELECTOR);
    if (!items.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -6% 0px', threshold: 0.05 }
    );

    Array.prototype.forEach.call(items, function (el) {
      var index = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.transitionDelay = Math.min(index, 3) * 70 + 'ms';
      el.classList.add('sm-reveal');
      observer.observe(el);
    });

    document.documentElement.classList.add('sm-reveal-on');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
